{
  "odometerVelocityWarning": {
    "title": "Odometer Verification",
    "message": "The odometer you entered suggests an average speed of {{velocity}} km/h between sessions. Is this correct?",
    "previousOdometer": "Previous odometer",
    "newOdometer": "New odometer",
    "difference": "Difference",
    "timeDifference": "Time difference",
    "question": "Is this odometer reading correct?",
    "confirm": "Yes, it's correct"
  },
  "odometerCorrection": {
    "title": "Correct Previous Session Odometer",
    "message": "The odometer you entered ({{new}} km) is lower than the previous session end ({{previous}} km). Would you like to correct the previous session's odometer?",
    "previousSession": "Previous Session",
    "date": "Date",
    "currentOdometer": "Current odometer",
    "correctedOdometerLabel": "Corrected odometer (km)",
    "observationsLabel": "Observations (required)",
    "confirm": "Correct Previous Session",
    "odometerRequired": "Please enter a valid odometer value.",
    "odometerInvalid": "Odometer must be a positive number.",
    "odometerTooHigh": "Corrected odometer must be less than {{previous}} km to allow starting with {{new}} km.",
    "observationsRequired": "Please provide observations explaining the correction."
  }
}





